import { Stack, Typography } from '@mui/material';
import { RootStyled } from './number-setting.styled';

interface NumberSettingProps {
  rank: number;
  label: string;
  caption?: string;
  hidden: boolean;
  children: React.ReactNode;
}

const NumberSetting = ({
  label,
  caption,
  rank,
  hidden = false,
  children,
}: NumberSettingProps) => {
  if (hidden) return null;
  return (
    <RootStyled attrs={{ hidden }}>
      <Typography variant="h4" mb={1} data-qa="number-setting">
        {rank}. {label}
      </Typography>
      {caption && (
        <Typography variant="caption" mb={1}>
          {caption}
        </Typography>
      )}
      <Stack direction="row" gap={1}>
        {children}
      </Stack>
    </RootStyled>
  );
};

export default NumberSetting;
